import { matchTypesEnum, matchTypesFromAmazon } from "../types/customers"

export const CAMPAIGN_STATES = {
  ENABLED: "ENABLED",
  PAUSED: "PAUSED",
  ARCHIVED: "ARCHIVED",
}

export const CAMPAIGN_STATES_FILTER = {
  ALL: "All",
  ENABLED: "Enabled",
  PAUSED: "Paused",
  ARCHIVED: "Archived",
  ALL_BUT_ARCHIVE: "All but archive",
}

export const CAMPAIGN_STATES_FILTER_ENUM = [
  CAMPAIGN_STATES_FILTER.ALL,
  CAMPAIGN_STATES_FILTER.ENABLED,
  CAMPAIGN_STATES_FILTER.ARCHIVED,
  CAMPAIGN_STATES_FILTER.PAUSED,
  CAMPAIGN_STATES_FILTER.ALL_BUT_ARCHIVE,
]

export const BEYOND_PAGE_RESULT = 2

export const MATCH_TYPES = [
  matchTypesEnum.ALL,
  matchTypesEnum.RANKING,
  matchTypesEnum.EXACT,
  matchTypesEnum.PHRASE,
  matchTypesEnum.BROAD,
  matchTypesEnum.ASIN,
  matchTypesEnum.AUTO,
  matchTypesEnum.ALL_NON_RANKING,
]

export const MATCH_TYPES_FROM_AMAZON = [
  matchTypesFromAmazon.EXACT,
  matchTypesFromAmazon.PHRASE,
  matchTypesFromAmazon.BROAD,
  matchTypesFromAmazon.OTHER,
]
